import { Fragment, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useNavigate } from 'react-router-dom';
import { Toaster, ToastIcon, toast, resolveValue } from 'react-hot-toast';
import { useDropdown } from '../store/dropdown-context';

const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className='transform p-4 flex bg-white rounded shadow-lg'
          enter='transition-all duration-150'
          enterFrom='opacity-0 scale-50'
          enterTo='opacity-100 scale-100'
          leave='transition-all duration-150'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-75'
        >
          <ToastIcon toast={t} />
          <p className='px-2'>{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
const ChangeNumberModal = ({
  open,
  setOpen,

  setError,
}) => {
  // const userLogin = useSelector((state) => state.userLogin);
  // const { userInfo } = userLogin;
  let navigate = useNavigate();
  const cancelButtonRef = useRef(null);
  const { agentNameContext } = useDropdown();
  const [phoneNumber, setPhoneNumber] = useState('');

  const blockHandler = () => {
    try {
      toast.success('تم العملية بنجاح');
      setOpen(false);
      navigate(`/${phoneNumber}/${agentNameContext}`);
    } catch (error) {
      setError(error);
      toast.error('حدث خطأ ما');
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as='div'
        className='fixed z-10 inset-0 overflow-y-auto'
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <div
          className='flex items-end justify-center min-h-screen px-4 pb-20 text-center sm:block sm:p-0'
          dir='rtl'
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
          </Transition.Child>

          <span
            className='hidden sm:inline-block sm:align-middle sm:h-screen'
            aria-hidden='true'
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            enterTo='opacity-100 translate-y-0 sm:scale-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
          >
            <div className='inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'>
              <div className='bg-white  pb-4 sm:pb-4 '>
                <div className='  grid grid-rows-3 grid-flow-col max-h-48'>
                  <div className='mx-auto flex-shrink-0 flex items-center justify-center h-12  w-full  align-middle bg-gray-100 px-4 '>
                    <Dialog.Title
                      as='h3'
                      className='text-lg leading-6 text-title-100 text-md text-center align-middle  py-1 px-2 pt-6'
                    >
                      تعديل رقم الهاتف
                    </Dialog.Title>
                  </div>
                  <div className='mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left row-start-2 row-end-3 '>
                    <div className='mt-2'>
                      <div className='px-4 py-2'>
                        <label
                          htmlFor=''
                          className=' text-title-100  block text-right '
                        >
                          <span className='text-right'>رقم الهاتف الجديد</span>
                        </label>
                      </div>
                      <div className='pt-2 px-4 '>
                        <input
                          type='text'
                          className='w-full  p-2 rounded-md shadow-sm border-2 border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-altaqnya-100 sm:text-sm '
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=' py-2 sm:px-6 justify-center flex'>
                <button
                  type='button'
                  className='text-white bg-button-100    font-medium  text-sm px-10 py-2.5 mr-2 mb-2    '
                  onClick={() => blockHandler(false)}
                  ref={cancelButtonRef}
                >
                  تأكيد
                </button>
                <button
                  type='button'
                  className='text-white bg-button-200    font-medium  text-sm px-10 py-2.5 mr-2 mb-2    '
                  onClick={() => setOpen(false)}
                  ref={cancelButtonRef}
                >
                  الغاء
                </button>
              </div>
            </div>
          </Transition.Child>
          <TailwindToaster />
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ChangeNumberModal;
